import React from "react"
import SectionHeader from "../../../SectionHeader/SectionHeader"
import CheckList from "../CheckList/CheckList"
import BoxList from './../BoxList/BoxList'
import * as styles from './ExpertCategory.module.scss'


const ExpertCategory = ({data, classes}) => {
   

    return(  
            <article className={`${styles.expertCategory} ${classes}` }>
                <SectionHeader color='navy' alignment='left' size='med'>{data.title1} <span>{data.title2}</span></SectionHeader>
                <p className={styles.expertCategory_text}>
                    {data.text}
                </p>
                { data.subHead && <div className={`${styles.subHeader}` }>{data.subHead}</div> }
                { data.checkList && <CheckList list={data.checkList}/> }
                { data.boxList &&  <BoxList list={data.boxList}/> }
           </article>          
    )
}

export default ExpertCategory